/* eslint-disable id-length */
export const getExportFileName = (baseName = 'ExportedFile') => {
  const now = new Date();
  const pad = (n) => n.toString().padStart(2, '0');
  return (
    `${baseName}-${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}-`
    + `${pad(now.getHours())}-${pad(now.getMinutes())}-${pad(now.getSeconds())}`
  );
};

export const getExportFileNameWithDate = (baseName = 'ExportedFile') => {
  const now = new Date();
  const pad = (n) => n.toString().padStart(2, '0');
  return `${baseName}-${pad(now.getDate())}-${pad(now.getMonth() + 1)}-${now.getFullYear()}`;
};
